"use client";

import * as stylex from "@stylexjs/stylex";
import * as Icons from "../../../icons";
/**
 * The underlying DOM element which is rendered by this component.
 */
const Root = "div";
function flatten(n, parents) {
  let ret = [];
  if (n.path) {
    ret.push({
      parents,
      label: n.label,
      path: n.path
    });
  }
  if (n.children) {
    ret = [...ret, ...n.children.flatMap(c => flatten(c, [...parents, n]))];
  }
  return ret;
}
export function NavigationFooter(props) {
  const {
    navigation,
    toc,
    ...rest
  } = props;
  const {
    Link,
    usePathname
  } = navigation;
  const pathname = usePathname();
  const items = toc.flatMap(n => flatten(n, []));
  const index = items.findIndex(v => v.path === pathname);
  if (index === -1) {
    return null;
  }
  function toLink(index_0) {
    const item = items[index_0];
    if (item === undefined) {
      return undefined;
    } else {
      return {
        href: item.path,
        label: item.label,
        context: item.parents.map(x => x.label).join(" / ")
      };
    }
  }
  const prev = toLink(index - 1);
  const next = toLink(index + 1);
  return <Root {...rest} className="xr1yuqi x13t10k xrvj5dj x3xbxsf x1u7e2r6 x1s3i72i x5diife">
      <div className="x1cmx39b x78zum5 x3ieub6 x8fetqu xkpwil5 x1evy7pa x1k046mz">
        {prev && <Link href={prev.href} className="xh8yej3 x78zum5 x1jnr06f xur7f20 xmkeg23 x1y0btm7 xj7gikm x1tamke2 x1heor9g x1hl2dhg xeuugli x1gtqa1q xdt5ytf x1cy8zhl x13a6bvl xdpxx8g">
            <div className="xvgvpxu x78zum5 x6s0dn4 xo4rrn4">
              <Icons.ChevronLeft className="x1q3kd3q x1n3ixbd" /> Previous
            </div>
            <div className="xk50ysn xb3r6kr xlyipyv x193iq5w">{prev.label}</div>
          </Link>}
        {next && <Link href={next.href} className="xh8yej3 x78zum5 x1jnr06f xur7f20 xmkeg23 x1y0btm7 xj7gikm x1tamke2 x1heor9g x1hl2dhg xeuugli x1gtqa1q xdt5ytf xuk3077 x1nhvcw1 x1hr2gdg">
            <div className="xvgvpxu x78zum5 x6s0dn4 xo4rrn4">
              Next <Icons.ChevronRight className="x1q3kd3q x1n3ixbd" />
            </div>
            <div className="xk50ysn xb3r6kr xlyipyv x193iq5w">{next.label}</div>
          </Link>}
      </div>
    </Root>;
}